'use client';

import { useState } from 'react';
import { useCalendarStore } from '@/stores/calendar-store';
import { uiFb } from '@/lib/i18n';
import { ReportModal } from './ReportModal';

interface ReportButtonProps {
  pageSlug: string;
  entityId?: string;
  pageTitle: string;
  pageCountry?: string;
  pageType?: 'event' | 'page';
}

export function ReportButton({ pageSlug, entityId, pageTitle, pageCountry, pageType = 'event' }: ReportButtonProps) {
  const [open, setOpen] = useState(false);
  const lang = useCalendarStore((s) => s.lang);

  return (
    <>
      <button
        onClick={() => {
          setOpen(true);
          window._paq?.push(['trackEvent', 'Report', 'Open', pageSlug]);
        }}
        className="inline-flex items-center gap-1.5 text-sm text-text-secondary transition-colors hover:text-text-primary"
      >
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true" className="shrink-0">
          <path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM8 5v3m0 2.5h.007" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {uiFb('ui.report_incorrect', 'Report incorrect data', lang)}
      </button>

      {open && (
        <ReportModal
          pageSlug={pageSlug}
          entityId={entityId}
          pageTitle={pageTitle}
          pageCountry={pageCountry}
          pageType={pageType}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
